import React from 'react'

export default function Page404() {
  return (
    <div className='d-flex align-items-center min-vh-100'>
      <div className='container'>
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className=''>
              <img src="../../images/404-page-not-found.gif" className='img-fluid' alt="" />
            </div>
          </div>
        </div>
        <div className='text-center pt-4'>
          <h1 className='text-primary'>Sorry, This Link is Out of Order!</h1>
        </div>
      </div>
    </div>
  )
}
